module.exports = __webpack_public_path__ + "static/media/logoVTZ2021.b1377dfb.svg";